module.exports = __webpack_public_path__ + "static/images/callout_2.0458391122a8794f20146148784d143c.jpg";